import React, { Component } from 'react';

class BiggestPainPoint extends Component {
	render() {
		return (
			<section className="assessment bg skin__concerns biggest__pain">
				<div className="container-fluid">
					<h1 className="assessment__heading">What is your biggest pain point in skincare?</h1>
					<div className="name__age--badges">
						<span>Not sure what’s right</span>
						<span>Feeling lost</span>
						<span>Clueless about ingredients</span>
						<span>Too busy!</span>
						<span>All of the above</span>
					</div>
				</div>
			</section>
		);
	}
}


export default BiggestPainPoint;